import React from "react";

import { formatInTimeZone } from "date-fns-tz";
import { Text } from "@pushpress/shared-components";

interface DateTimeStartEndProps {
  startTime: string;
  endTime: string;
  timezone: string;
}

function DateTimeStartEndCell({
  startTime,
  endTime,
  timezone,
}: DateTimeStartEndProps) {
  if (
    isNaN(new Date(startTime).getTime()) ||
    isNaN(new Date(endTime).getTime())
  ) {
    return (
      <Text variant="body-lg" color="wolf-600">
        - -
      </Text>
    );
  }

  const start = formatInTimeZone(new Date(startTime), timezone, "h:mmaaa");
  const end = formatInTimeZone(new Date(endTime), timezone, "h:mmaaa");

  return (
    <>
      <Text variant="body-lg" color="wolf-800">
        {formatInTimeZone(new Date(startTime), timezone, "EEEE, MMM dd, yyyy")}
      </Text>
      <Text variant="body-lg" color="wolf-600">
        {`${start} - ${end}`}
      </Text>
    </>
  );
}

export default DateTimeStartEndCell;
